import { SWRConfiguration } from "swr";

import { QueryParams, useAPI } from "./useAPI";
import { useSubmit, UseSubmitOptions } from "./useSubmit";
import { paths as appPaths } from "../generated-schemas/client-portal";
import { paths as sharedPaths } from "../generated-schemas/shared";
import {
  GetRequest,
  CombinedPaths,
  PostRequest,
  ExtractPostResponseData,
  ExtractPostRequestBody,
  FilterByFetchType,
  InferAPI,
  InferAPIOptions,
} from "../types";

type GetSchemas = CombinedPaths<
  FilterByFetchType<appPaths & sharedPaths, GetRequest>
>;
type PostSchemas = CombinedPaths<
  FilterByFetchType<appPaths & sharedPaths, PostRequest>
>;

type PostPaths = keyof PostSchemas;
export type GetPaths = keyof GetSchemas;

export const useClientPortalAPI = <PATH extends GetPaths>(
  path: PATH | null,
  query?: QueryParams,
  options?: SWRConfiguration
) => {
  type Responses = GetSchemas[PATH]["get"]["responses"];
  type Data = Responses[200]["content"]["application/json"];
  return useAPI<Data>(path, query, options);
};

export type InferClientPortalAPI<
  PATH extends GetPaths,
  Options extends InferAPIOptions = "data",
> = InferAPI<typeof useClientPortalAPI<PATH>, Options>;

export const useClientPortalSubmit = <PATH extends PostPaths>(
  path: PATH,
  options?: UseSubmitOptions<ExtractPostResponseData<PostSchemas, PATH>>
) => {
  return useSubmit<
    ExtractPostResponseData<PostSchemas, PATH>,
    ExtractPostRequestBody<PostSchemas, PATH>
  >(path, options || {});
};
